<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Receipt
    </Teleport>

    <h2 class="cf-title cf-title--2">
      Thanks for your order!
    </h2>

    <h3 class="cf-title cf-title--3 cf-text-align-left">
      Your Order
    </h3>

    <div
      v-if="receipt.isReload"
      class="key-value dist-y-half"
    >
      <dl class="key-value__row">
        <dt class="key-value__key">
          Funds Added
        </dt>

        <dd class="key-value__value bold">
          {{ dollars(receipt.total) }}
        </dd>
      </dl>

      <dl class="key-value__row">
        <dt class="key-value__key">
          New Card Balance
        </dt>
        <dd class="key-value__value primary bold">
          {{ dollars(receipt.balance) }}
        </dd>
      </dl>
    </div>

    <div
      v-else
      class="cf-flex cf-flex--column cf-flex--gap-16"
    >
      <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between">
        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-12">
          <h4 class="cf-title cf-title--4">
            1
          </h4>

          <h4 class="cf-title cf-title--4">
            Gift Card
          </h4>
        </div>

        <p class="cf-subtitle cf-subtitle--2">
          {{ dollars(receipt.total) }}
        </p>
      </div>

      <cf-title-separator :omit-title="true" />

      <div class="cf-key-value">
        <dl class="cf-key-value__row cf-key-value__row--large">
          <dt class="cf-key-value__key">
            Total
          </dt>

          <dd class="cf-key-value__value">
            {{ dollars(receipt.total) }}
          </dd>
        </dl>
      </div>

      <cf-title-separator :omit-title="true" />
    </div>

    <template v-if="receipt.autoReload">
      <h3 class="cf-title cf-title--3">
        Auto Reload Details
      </h3>

      <p class="cf-subtitle cf-subtitle--2">
        Reload <span class="bold primary">{{ dollars(receipt.autoReload.reloadAmount, { trimZeros: true }) }}</span>
        when your card balance is below <span class="bold primary">{{ dollars(receipt.autoReload.thresholdTriggerAmount, { trimZeros: true }) }}</span>
      </p>
    </template>

    <div
      v-if="receipt.recipientInfo"
      class="cf-flex cf-flex--column cf-flex--gap-16"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-8">
        <h3 class="cf-title cf-title--3 cf-text-align-left">
          Recipient Info
        </h3>

        <div class="cf-flex cf-flex--column cf-text-align-left">
          <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
            {{ receipt.recipientInfo.fullName }}
          </p>

          <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between">
            <p class="cf-subtitle cf-subtitle--2">
              <template v-if="receipt.recipientInfo.primarySmsNumber">
                {{ $phone(receipt.recipientInfo.primarySmsNumber) }}
              </template>

              <template v-else>
                {{ receipt.recipientInfo.email }}
              </template>
            </p>
          </div>
        </div>

        <p
          v-if="receipt.message"
          class="cf-quote cf-subtitle cf-subtitle--3 cf-text-align-left"
        >
          {{ receipt.message }}
        </p>
      </div>

      <cf-title-separator :omit-title="true" />
    </div>

    <!-- Contact & Payment Info -->
    <div class="cf-flex cf-flex--column cf-flex--gap-8 cf-text-align-left">
      <h3 class="cf-title cf-title--3">
        Contact & Payment Info
      </h3>

      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <div class="cf-flex cf-flex--column cf-flex--gap-6">
          <h4 class="cf-title cf-tile--4">
            {{ receipt.contactInfo.fullName }}
          </h4>

          <p
            v-if="receipt.contactInfo.phoneNumber"
            class="cf-subtitle cf-subtitle--2"
          >
            {{ $phone(receipt.contactInfo.phoneNumber) }}
          </p>

          <p
            v-if="receipt.contactInfo.email"
            class="cf-subtitle cf-subtitle--2"
          >
            {{ receipt.contactInfo.email }}
          </p>
        </div>

        <cf-title-separator :omit-title="true" />

        <cf-your-payment-details :payment="formattedPayment" />
      </div>
    </div>

    <button
      v-if="canRedirectToGiftCardManagement"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      type="button"
      @click="backToGiftCards"
    >
      Back to Gift Cards
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import dollars from '@/filters/dollars';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfYourPaymentDetails from '@/view/components/globals/cf-your-payment-details/index.vue';


  export default {
    name: 'GiftCardReceipt',

    components: {
      CfYourPaymentDetails,
      CfTitleSeparator
    },

    props: {
      receipt: {
        type: Object,
        required: true
      },

      overrideReceiptNavigation: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('session', ['currentUser']),

      yourPayment() {
        return {
          payments: [this.receipt.payment],
          transactionDateTime: this.receipt.payment.transactionDateTime
        };
      },

      canRedirectToGiftCardManagement() {
        return this.currentUser.accountId
          && this.$route.name !== 'paymentMethodsGiftCards'
          && !this.overrideReceiptNavigation;
      },

      formattedPayment() {
        return { ...this.receipt.payment, payments: [this.receipt.payment] };
      }
    },

    methods: {
      dollars,

      backToGiftCards() {
        this.$closeAllModals();

        this.$router.push({
          name: 'paymentMethodsGiftCards',
          params: {
            merchantId: this.$route.params.merchantId
          }
        });
      }
    }
  };
</script>
